import Scheduler, { Editing, Resource } from "devextreme-react/scheduler";
import React, { useCallback, useState } from "react";
import { isMobile } from "../../../Utils/media-query";
import useHandleHoursByUserId from "../../../Hooks/useHandleData/useHandleHoursByUserId";
import ErrorMessage from "../../../Components/ErrorMessage";
import AppointmentTooltip from "./appointmentTooltip";
import { LoadPanel } from "devextreme-react/load-panel";
import useGetHolidays from "../../../Hooks/useGET/useGetHolidays";

const position = { of: "#calender" };
const views = ["day", "week", "month"];
const color = [
  { id: 1, text: "Work Orders", color: "#FFDB00" },
  { id: 2, text: "Approved Time Off", color: "rgba(3, 148, 135, 0.3)" },
  { id: 3, text: "Pending Time Off", color: "rgba(238, 238, 238, 0.5)" },
];
const todaysDate = new Date(),
  dateCheck = new Date(Date.now() - 8 * 24 * 60 * 60 * 1000); //gets 8 days before current date

export default function Calendar({
  scedulerData,
  isOtherUser,
  handleUpdateForm,
  handleNewForm,
  /*RenderWeekCell,*/
  onContentReady,
  handleCellContextMenu,
  handleAppointmentContextMenu,
  userId,
  scheduleObject,
  hoursByDay,
}) {
  const { error, isLoading } = useHandleHoursByUserId(userId);
  const [curentYear, setCurrentYear] = useState(todaysDate.getFullYear()),
    [curentMonth, setCurrentMonth] = useState(todaysDate.getMonth() + 1);

  const { holiday } = useGetHolidays(curentYear, curentMonth);
  const handleOptionChanged = useCallback((e) => {
    if (e.fullName === "currentDate") {
      const date = e.value;
      setCurrentYear(date.getFullYear());
      setCurrentMonth(date.getMonth() + 1);
    }
  }, []);

  const renderHolidayCell = useCallback(
    (cellData) => {
      const date = cellData.startDate;
      let holidayForDay = null;

      if (date) {
        const cellDateStr = date.toLocaleDateString("sv-SE");

        holidayForDay = holiday?.find(
          (h) => new Date(h.value).toLocaleDateString("sv-SE") === cellDateStr
        );
      }

      return (
        <div className="dx-scheduler-date-cell-inner">
          <div>{cellData.text}</div>

          {holidayForDay && (
            <div className="holiday-label">{holidayForDay.label}</div>
          )}
        </div>
      );
    },
    [holiday]
  );
  const handleToolTip = useCallback(
    (e) => {
      return (
        <AppointmentTooltip
          e={e}
          userId={userId}
          handleUpdateForm={handleUpdateForm}
          scheduleObject={scheduleObject}
        />
      );
    },
    [handleUpdateForm, userId, scheduleObject]
  );

  const onAppointmentDblClick = useCallback(
    (e) => {
      e.cancel = true;
      const startDate = new Date(e.appointmentData.startDate);

      if (startDate > todaysDate || (!isOtherUser && startDate < dateCheck)) {
        return;
      }
      handleUpdateForm(e.appointmentData);
    },
    [handleUpdateForm, isOtherUser]
  );

  const onCellClick = useCallback(
    (e) => {
      e.cancel = true;
      const startDate = new Date(e.cellData.startDate);

      if ((!isOtherUser && startDate < dateCheck) || startDate > todaysDate) {
        return;
      }
      handleNewForm(startDate);
    },
    [handleNewForm, isOtherUser]
  );

  const injectHeaderPills = useCallback(() => {
    const panel = document.querySelector(
      "#scheduler-calender .dx-scheduler-header-panel"
    );
    if (!panel) return;

    const cells = panel.querySelectorAll(".dx-scheduler-header-panel-cell");
    if (!cells?.length) return;

    const weekdayNames = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    const shortLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const todayIdx = new Date().getDay(); // <-- add this

    cells.forEach((cell, i) => {
      const hours = hoursByDay?.[weekdayNames[i]] ?? 0;
      const todayClass = i === todayIdx ? " is-today" : ""; // <-- add this
      cell.innerHTML = `
      <div class="weekday-col${todayClass}">
        <span class="weekday-label">${shortLabels[i]}</span>
        ${
          hours > 0
            ? `<span class="hours-pill">${
                Number.isInteger(hours) ? hours : hours.toFixed(1)
              }h</span>`
            : ""
        }
      </div>
    `;
    });
  }, [hoursByDay]);

  if (error)
    return (
      <div className="contentBox my-3">
        <ErrorMessage />
      </div>
    );

  return (
    <div id="calender" className="row">
      <LoadPanel
        visible={isLoading}
        position={position}
        shading={true}
        shadingColor="rgba(0,0,0,0.4)"
      />

      <Scheduler
        id="scheduler-calender"
        dataSource={scedulerData}
        views={views}
        defaultCurrentView="month"
        defaultCurrentDate={todaysDate}
        height="auto"
        startDayHour={0}
        adaptivityEnabled={isMobile}
        appointmentTooltipComponent={handleToolTip}
        onContentReady={(e) => {
          injectHeaderPills();
          onContentReady && onContentReady(e);
        }}
        dataCellRender={renderHolidayCell}
        timeCellRender={renderHolidayCell}
        onOptionChanged={handleOptionChanged}
        onCellContextMenu={handleCellContextMenu}
        onAppointmentContextMenu={handleAppointmentContextMenu}
        onAppointmentDblClick={onAppointmentDblClick}
        onCellClick={onCellClick}
      >
        <Resource
          fieldExpr="colorId"
          dataSource={color}
          useColorAsDefault={true}
        />
        <Editing allowResizing={false} allowDragging={false} />
      </Scheduler>
    </div>
  );
}
